/*
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 * @Description: 通用短信营销-自动化营销主界面
 */
import React, { useState, useEffect } from 'react';
import { Tab } from '@alifd/next';
import style from './index.module.scss';
import utils from '@/common/utils';
import MarketingCreateActivity from './MarketingCreateActivity';
import MarketingActivityList from './MarketingActivityList';

const TabItem = Tab.Item;

const PrivateAutoMarketingModel = (props) => {
  // tab 状态
  const [currentKey, setCurrentKey] = useState("createActivities");
  const tabsList = { createActivities: '创建活动', activitiesList: '活动列表' };
  // 如果是从结果数据跳转回来的 赋值 传给组件 MarketingActivityList
  const [from,setForm] = useState("");
  const [paramsFromView, setParamsFromView] = useState('')
  useEffect(() => {
    // 设置面包屑
    utils.setBreadcrumb({
      name: '模型',
      url: '/web/smsautomarket/marketing',
      children: {
        name: '自动化营销管理',
        url: '/web/smsautomarket/marketing',
      },
    });
    // props.location.state 是否为空
    if (props.location.state) {
      // 查看详情后“返回”按钮  || 复制的“取消”按钮 都跳转到列表页tab
      if (props.location.state.from == "resultData" || props.location.state.from == "cancle" && props.location.state.checkType == 2) {
        setCurrentKey("activitiesList");
        setForm("resultData");
        if(props.location.state.from == "resultData" && props.location.state.params) {
          setParamsFromView(JSON.parse(props.location.state.params))
          props.history.replace('/smsautomarket/marketing',{from:"resultData",params: null})
        }
      }else if (props.location.state.from == "cancle" && props.location.state.checkType == 1){ //新建的“取消”按钮 跳转到新建页tab
        setCurrentKey("createActivities");
      }
    }
    // console.log(props);
  }, [])
  return (
    <div className="setTabsStyle">
      <Tab
        animation
        navClassName={style.tabsStyle}
        activeKey={currentKey}
        onChange={(v) => (setCurrentKey(v))}
        className="tabStyle_hjy"
      >
        {Object.keys(tabsList).map((key) => {
          return (<TabItem title={tabsList[key]} key={key} />);
        })}
      </Tab>

      <div className={style.mainBox}>
        {currentKey === 'createActivities' && <MarketingCreateActivity />}
        {currentKey === 'activitiesList' && <MarketingActivityList from={from} paramsFromView={paramsFromView} />}
      </div>
    </div>
  )
}

export default PrivateAutoMarketingModel
